import { render, staticRenderFns } from "./InvestorsInvitedCard.vue?vue&type=template&id=354554e4&"
import script from "./InvestorsInvitedCard.vue?vue&type=script&lang=js&"
export * from "./InvestorsInvitedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports